var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea-autosize',_vm._g(_vm._b({staticClass:"scroll cc-input",attrs:{"value":_vm.value,"readonly":_vm.readonly,"placeholder":_vm.readonly ? null : _vm.placeholder,"rows":"1"}},'textarea-autosize',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }